import { State as DataQueryState } from '@progress/kendo-data-query';
import modifyDeep from '../modifyDeep';
import { cloneDeep } from 'lodash';
import { GridFilterOperators } from '@progress/kendo-react-grid';
const getRequestPayloadFromQueryState = (queryState: DataQueryState, fieldsMapper?: FieldMapping[]) => {
    const dataState = {
        page: queryState.skip! / queryState.take! + 1,
        pageSize: queryState.take!,
        sort: cloneDeep(queryState.sort),
        filter: cloneDeep(queryState.filter),
        // group: queryState.group,
    };

    if (!fieldsMapper) return dataState;

    mapFieldValues(dataState.sort, fieldsMapper);
    mapFieldValues(dataState.filter, fieldsMapper);

    return dataState;
};

export interface FieldMapping {
    frontFieldName: any;
    backFieldName: any;
}

const mapFieldValues = (object: any, fieldsMapper: FieldMapping[]) => {
    const frontFieldNames = fieldsMapper.map((fieldMapping) => fieldMapping.frontFieldName);

    modifyDeep(object, (key, value) => {
        if (typeof key !== 'string' || key.toLowerCase() !== 'field') {
            return value;
        }

        if (frontFieldNames.includes(value)) {
            return fieldsMapper.find((fieldMapping) => fieldMapping.frontFieldName === value)?.backFieldName;
        }

        return value;
    });
};

export const getDefaultFieldOperatorsByType = (type: string) => {
    if (type === 'date') {
        return {
            date: [
                { text: 'grid.filterLteOperator', operator: 'lte' },
                { text: 'grid.filterGteOperator', operator: 'gte' },
                { text: 'grid.filterLtOperator', operator: 'lt' },
                { text: 'grid.filterGtOperator', operator: 'gt' },
            ],
        };
    }
    return null;
};
export { getRequestPayloadFromQueryState };
